export const Menu = ({ width = 26, height = 26 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 3H15.5V8H10.5V3ZM18 3H23V8H18V3ZM3 3H8V8H3V3Z"
        fill="white"
      />

      <path
        d="M10.5 10.5H15.5V15.5H10.5V10.5ZM18 10.5H23V15.5H18V10.5ZM3 10.5H8V15.5H3V10.5Z"
        fill="white"
      />

      <path d="M15.5 17.375H10.5V22.375H15.5V17.375Z" fill="white" />
      <path d="M23 17.375H18V22.375H23V17.375Z" fill="white" />
      <path d="M8 17.375H3V22.375H8V17.375Z" fill="white" />
    </svg>
  );
};
